module.exports = __webpack_public_path__ + "img/d7.772435e1.jpg";